const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "pblv_admin_token";
const BENE_TOKEN_KEY = "tpoz_bene_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

async function request(method, path, body, opts = {}) {
  const headers = {};
  if (body !== undefined) headers["Content-Type"] = "application/json";
  const tokenKey = opts.tokenKey || TOKEN_KEY;
  const token = localStorage.getItem(tokenKey);
  if (token) headers.Authorization = `Bearer ${token}`;

  const res = await fetch(BASE + path, {
    method,
    headers,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });

  const text = await res.text();
  let data = null;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    data = text;
  }

  if (!res.ok) {
    const err = new Error(`Request failed (${res.status})`);
    err.response = { status: res.status, data };
    throw err;
  }
  return { data };
}

// Minimal axios-like client backed by fetch (reliable in this environment).
export const api = {
  get: (path, opts) => request("GET", path, undefined, opts),
  post: (path, body, opts) => request("POST", path, body, opts),
  put: (path, body, opts) => request("PUT", path, body, opts),
  patch: (path, body, opts) => request("PATCH", path, body, opts),
  delete: (path, opts) => request("DELETE", path, undefined, opts),
};

// Dedicated client for beneficiaire endpoints (uses BENE_TOKEN_KEY).
export const beneApi = {
  get: (path) => request("GET", path, undefined, { tokenKey: BENE_TOKEN_KEY }),
  post: (path, body) => request("POST", path, body, { tokenKey: BENE_TOKEN_KEY }),
};

export { BENE_TOKEN_KEY };

export async function downloadCsv(path, filename) {
  const token = getToken();
  const res = await fetch(BASE + path, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!res.ok) {
    const err = new Error(`Download failed (${res.status})`);
    err.response = { status: res.status };
    throw err;
  }
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export async function downloadFile(path, filename, body) {
  const token = getToken();
  const res = await fetch(BASE + path, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify(body || {}),
  });
  if (!res.ok) {
    const err = new Error(`Download failed (${res.status})`);
    err.response = { status: res.status };
    throw err;
  }
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export function formatApiError(detail) {
  if (detail == null) return "Une erreur est survenue. Réessayez.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
